

// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// const MCompletedBooking = () => {
//   const navigate = useNavigate(); // Initialize the navigate function

//   const bookings = [
//     {
//       date: "08 Oct 2024",
//       timeStart: "09:00 AM",
//       timeEnd: "09:00 PM",
//       location: "Cantonment complex, Opp Mangesh Honda",
//       bookingId: "240870010015",
//       amount: "₹900.00",
//       status: "Cancelled",
//     },
//     {
//       date: "08 Oct 2024",
//       timeStart: "09:00 AM",
//       timeEnd: "09:00 PM",
//       location: "Cantonment complex, Opp Mangesh Honda",
//       bookingId: "240870010015",
//       amount: "₹790.00",
//       status: "Completed",
//     },
//     {
//       date: "08 Oct 2024",
//       timeStart: "09:00 AM",
//       timeEnd: "09:00 PM",
//       location: "Cantonment complex, Opp Mangesh Honda",
//       bookingId: "240870010015",
//       amount: "₹900.00",
//       status: "Cancelled",
//     },
//     {
//       date: "08 Oct 2024",
//       timeStart: "09:00 AM",
//       timeEnd: "09:00 PM",
//       location: "Cantonment complex, Opp Mangesh Honda",
//       bookingId: "240870010015",
//       amount: "₹900.00",
//       status: "Cancelled",
//     },
//   ];

//   // Function to handle the redirection
//   const handleMoreDetails = (bookingId) => {
//     navigate('/mobile-moredetails');
//   };

//   return (
//     <div className="p-4 bg-gray-100 flex justify-center w-full">
//       <div className="w-full rounded-lg">
//         {/* Booking Cards */}
//         <div className="space-y-4">
//           {bookings.map((booking, index) => (
//             <div
//               key={index}
//               className="rounded-lg p-4 flex flex-col space-y-3 border border-gray-200"
//             >
//               {/* Date and Time */}
//               <div className="flex justify-between items-center text-sm text-gray-600">
//                 <span className="font-semibold text-gray-800">
//                   {booking.date} {booking.timeStart}
//                 </span>
//                 <span>to</span>
//                 <span className="font-semibold text-gray-800">
//                   {booking.date} {booking.timeEnd}
//                 </span>
//               </div>

//               {/* Location */}
//               <div className="text-sm text-gray-500 font-medium">
//                 {booking.location}
//               </div>

//               {/* Booking ID and Amount */}
//               <div className="flex justify-between text-sm text-gray-600">
//                 <span className="font-semibold">Booking ID</span>
//                 <span className="text-gray-700">{booking.bookingId}</span>
//               </div>
//               <div className="flex justify-between text-sm text-gray-600">
//                 <span className="font-semibold">Total Amount</span>
//                 <span className="text-gray-700">{booking.amount}</span>
//               </div>

//               {/* Status */}
//               <div className="flex justify-between items-center text-sm">
//                 <span className="font-semibold">Booking Status</span>
//                 <span
//                   className={`font-semibold ${
//                     booking.status === "Completed"
//                       ? "text-green-600"
//                       : "text-red-600"
//                   }`}
//                 >
//                   {booking.status}
//                 </span>
//               </div>

//               {/* More Details Link */}
//               <div className="text-right">
//                 <button
//                   onClick={() => handleMoreDetails(booking.bookingId)} // Call the function with bookingId
//                   className="text-[#FF9630] font-semibold text-sm hover:underline"
//                 >
//                   More Details &gt;
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MCompletedBooking;


import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MobileMoreDetails from './MobileMoreDetails'; // Adjust the import path if necessary

const MCompletedBooking = () => {
  const [selectedBookingId, setSelectedBookingId] = useState(null); // State to track the selected booking ID
  const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility

  const bookings = [
    // Booking data remains the same
    {
      date: "08 Oct 2024",
      timeStart: "09:00 AM",
      timeEnd: "09:00 PM",
      location: "Cantonment complex, Opp Mangesh Honda",
      bookingId: "240870010015",
      amount: "₹900.00",
      status: "Cancelled",
    },
    {
      date: "08 Oct 2024",
      timeStart: "09:00 AM",
      timeEnd: "09:00 PM",
      location: "Cantonment complex, Opp Mangesh Honda",
      bookingId: "240870010016",
      amount: "₹790.00",
      status: "Completed",
    },
  ];

  const openModal = (bookingId) => {
    setSelectedBookingId(bookingId); // Set the selected booking ID
    setIsModalOpen(true); // Open the modal
  };

  const closeModal = () => {
    setSelectedBookingId(null); // Clear the selected booking ID
    setIsModalOpen(false); // Close the modal
  };

  return (
    <div className="p-4 bg-gray-100 flex justify-center w-full">
      <div className="w-full rounded-lg">
        <div className="space-y-4">
          {bookings.map((booking, index) => (
            <div
              key={index}
              className="rounded-lg p-4 flex flex-col space-y-3 border border-gray-200"
            >
              <div className="flex justify-between items-center text-sm text-gray-600">
                <span className="font-semibold text-gray-800">
                  {booking.date} {booking.timeStart}
                </span>
                <span>to</span>
                <span className="font-semibold text-gray-800">
                  {booking.date} {booking.timeEnd}
                </span>
              </div>
              <div className="text-sm text-gray-500 font-medium">
                {booking.location}
              </div>
              <div className="flex justify-between text-sm text-gray-600">
                <span className="font-semibold">Booking ID</span>
                <span className="text-gray-700">{booking.bookingId}</span>
              </div>
              <div className="flex justify-between text-sm text-gray-600">
                <span className="font-semibold">Total Amount</span>
                <span className="text-gray-700">{booking.amount}</span>
              </div>
              <div className="flex justify-between items-center text-sm">
                <span className="font-semibold">Booking Status</span>
                <span
                  className={`font-semibold ${
                    booking.status === "Completed"
                      ? "text-green-600"
                      : "text-red-600"
                  }`}
                >
                  {booking.status}
                </span>
              </div>
              <div className="text-right">
                <button
                  onClick={() => openModal(booking.bookingId)}
                  className="text-[#FF9630] font-semibold text-sm hover:underline"
                >
                  More Details &gt;
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Modal */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="relative bg-white rounded-lg shadow-lg w-full p-4">
              <button
                onClick={closeModal}
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              >
                &times;
              </button>
              <MobileMoreDetails bookingId={selectedBookingId} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MCompletedBooking;
